module.exports = __webpack_public_path__ + "img/vir-pro.5cedf5f3.svg";